import React from 'react';
import { getLeavePolicy, formatLeaveUnit } from '../utils/leavePolicies';

const LeaveTypeGuidelines = ({ leaveTypes }) => {
  if (!leaveTypes?.length) {
    return null;
  }

  return (
    <section className="mt-5">
      <div className="flex align-items-center justify-content-between mb-3">
        <h3>İzin Kullanım Kuralları</h3>
        <span className="text-sm text-color-secondary">
          Backend tanımlarındaki güncel kota ve kurallar otomatik olarak görüntülenir.
        </span>
      </div>
      <div className="grid">
        {leaveTypes.map((type) => {
          const policy = getLeavePolicy(type);
          const unitLabel = formatLeaveUnit(type.unit);
          return (
            <div className="col-12 md:col-6 lg:col-4" key={type.id}>
              <div className="p-card p-3 border-round surface-card shadow-1 h-full flex flex-column">
                <h4 className="mb-2">{type.name}</h4>
                <div className="text-sm text-color-secondary mb-3">
                  {type.default_allocation !== null && type.default_allocation !== undefined && (
                    <div><strong>Varsayılan Kota:</strong> {type.default_allocation} {unitLabel}</div>
                  )}
                  {type.unit && (
                    <div><strong>İzin Birimi:</strong> {unitLabel}</div>
                  )}
                  {type.carryover && <div><strong>Devrolma:</strong> Kullanılmayan izin bir sonraki döneme devreder.</div>}
                </div>
                {policy ? (
                  <div className="flex flex-column gap-2">
                    <h5 className="mb-1 text-sm text-color-secondary">{policy.title}</h5>
                    <ul className="pl-3 text-sm">
                      {policy.summary.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                    {policy.notes?.length ? (
                      <div className="text-xs text-color-secondary">
                        {policy.notes.map((note, index) => (
                          <div key={index}>* {note}</div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <p className="text-sm text-color-secondary">
                    Bu izin tipine ait detaylı kullanım kuralı henüz tanımlanmamış.
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LeaveTypeGuidelines;
